import React, { ReactNode } from 'react';

import { Box, Skeleton, Typography } from '@mui/material';
import { Panel, PanelContent } from '@apigrowfinance/pbolt-panel';
import { CustomTheme } from '@apigrowfinance/pbolt-theme-provider';

import LoadingError from '@components/loadingError/LoadingError';

export type CurrentBalanceProps = {
    title: ReactNode;
    currentBalance: ReactNode;
    isLoading: boolean;
    isError: boolean;
};

const CurrentBalance = ({
    title,
    currentBalance,
    isLoading,
    isError,
}: CurrentBalanceProps) => {
    if (isError) {
        return (
            <Panel>
                <PanelContent>
                    <LoadingError />
                </PanelContent>
            </Panel>
        );
    }

    return (
        <Panel>
            <PanelContent>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}>
                    <Typography
                        variant="overline"
                        data-testid="current-balance-typography">
                        {isLoading ? (
                            <Skeleton width={120} data-testid="title-loader" />
                        ) : (
                            title
                        )}
                    </Typography>
                    <Typography
                        variant="h1"
                        data-testid="current-balance-value"
                        sx={(theme: CustomTheme) => ({
                            color: theme.custom.brand.textMain,
                            fontWeight: 600,
                        })}>
                        {isLoading ? (
                            <Skeleton
                                width={160}
                                data-testid="current-balance-loader"
                            />
                        ) : (
                            currentBalance
                        )}
                    </Typography>
                </Box>
            </PanelContent>
        </Panel>
    );
};

export default CurrentBalance;
